import { Estado } from "../Others/iDataEstado";

export enum PlansTypes {
  PRIVADO = "Privado",
  PUBLICO = "Público",
  CAMPAÑA = "Campaña",
  TODOS = "Todos",
}

export interface iDataPlan {
  id_plan: string;
  nombre: string;
  descripcion: string;
  precio: number;
  duracion: number;
  total_creditos: number;
  max_usuarios: number;
  creditos_mensuales: number;
  id_tipo_plan: string;
  tipo_plan: string;
  id_organizacion: string | null;
  organizacion: string | null;
  id_estado: string;
  estado: Estado;
  created_at: string;
  updated_at: string;
  version: string;
}

export type PostPlanFields = Pick<
  iDataPlan,
  | "nombre"
  | "descripcion"
  | "precio"
  | "duracion"
  | "creditos_mensuales"
  | "max_usuarios"
  | "id_tipo_plan"
  | "id_organizacion"
  | "total_creditos"
  | "version"
>;

export type PutPlanFields = Pick<
  iDataPlan,
  | "nombre"
  | "descripcion"
  | "precio"
  | "duracion"
  | "creditos_mensuales"
  | "max_usuarios"
  | "total_creditos"
  | "estado"
>;
